'use strict';

var d3 = require('d3');
var _ = require('lodash');
var XAxis = function XAxis(d3Helper, constants) {
  /**
   * @param xAxisTickFormatter - a formatter for displaying tickers
   * @param xAxisTickValues - a formatter for determining which ticks should be displayed
   * @returns {Function}
   * @constructor
   */
  var Axis = function Axis(xAxisTickFormatter, xAxisTickValues) {
    var params, scales;
    var textRotation, noLine, repetition, axisLabel, invertAxisLine;
    var mode = constants.AXIS.MODE.BOTTOM;
    var isTopAxis = mode === constants.AXIS.MODE.TOP;
    var isBottomAxis = mode === constants.AXIS.MODE.BOTTOM;
    /**
     * Constructs axis DOM element
     * @param container
     */
    var createXAxis = function createXAxis(container) {
      var domain = scales.xScale.domain();
      var xAxis = d3.svg.axis().scale(scales.xScale).orient(mode).ticks(params.xNumberOfTicks).tickFormat(xAxisTickFormatter);
      if (!_.isUndefined(params.xAxisTickSize)) {
        xAxis.tickSize(params.xAxisTickSize);
      }
      if (!params.isSparse) {
        if (xAxisTickValues) {
          xAxis.tickValues(xAxisTickValues);
        } else if (scales.xScale.rangeBand) {
          var width = scales.xScale.rangeBand();
          var labelAlwaysPresentBarWidth = 40;
          var times = repetition || (width > labelAlwaysPresentBarWidth ? 1 : Math.round(labelAlwaysPresentBarWidth / width));
          xAxis.tickValues(domain.filter(function (d, i) {
            return i % times === 0;
          }));
        }
      }
      var padding = params.padding.top + params.padding.bottom;
      var yShift = params.containerHeight - padding;
      var xAxisGroup = d3Helper.createGroupElement(container, 'x-axis-' + mode);
      var yTranslation = (isBottomAxis ? yShift : 0) + (params.xAxisShift || 0);
      xAxisGroup.call(xAxis).attr('transform', 'translate(' + [0, yTranslation] + ')').selectAll('.tick text').call(d3Helper.breakLabelIntoSeparateLines);
      if (noLine) {
        xAxisGroup.select('path').remove();
      }
      if (invertAxisLine) {
        xAxisGroup.select('path').attr('transform', 'translate(' + [0, -(yShift + (params.xAxisShift || 0) + 1)] + ')');
      }
      if (textRotation) {
        xAxisGroup.selectAll('text').attr(textRotation).style('text-anchor', params.yAxisTextRotationAnchor || 'end');
      }
      if (params.xAxisTextShift) {
        xAxisGroup.selectAll('.tick').attr('transform', function () {
          var tickTransform = d3.transform(d3.select(this).attr('transform'));
          return 'translate(' + tickTransform.translate[0] + ',' + tickTransform.translate[1] + params.xAxisTextShift + ')';
        });
      }
      if (params.isSparse) {
        xAxisGroup.selectAll('.tick text').attr({
          'transform': function transform(d) {
            var xTranslate = params.xWidthFromLengthOfStay(d) / 2;
            return 'translate(' + xTranslate + ', 8)';
          }
        });
      }
    };

    /**
     * Constructs labels DOM element
     * @param container
     */
    function xAxisText(container) {
      if (!axisLabel) {
        return;
      }
      var label = container.selectAll('.x-axis-label').data([null]);
      label.enter().append('text');
      var translate = [(params.width - params.padding.right) / 2 + (params.xAxisLabelHorizontalShift || 0), params.height + (params.xAxisLabelShift || 0)];
      label.text(axisLabel).attr({
        'class': 'x-axis-label',
        'transform': 'translate(' + translate + ')'
      }).style('text-anchor', 'middle');
    }

    /**
     *
     * @param container
     */
    var xAxis = function xAxis(container) {
      d3Helper.createGroupElement(container, 'group-axes').call(createXAxis).call(xAxisText);
    };

    /**
     *  Setters and getters
     */

    xAxis.label = function (value) {
      axisLabel = value;
      return xAxis;
    };
    xAxis.withoutLine = function () {
      noLine = true;
      return xAxis;
    };
    xAxis.withRepetition = function (_repetition) {
      repetition = _repetition;
      return xAxis;
    };
    xAxis.withTextRotation = function (rotation) {
      textRotation = rotation;
      return xAxis;
    };
    xAxis.params = function (value) {
      params = value;
      return xAxis;
    };
    xAxis.scales = function (value) {
      scales = value;
      return xAxis;
    };
    xAxis.invertAxisLine = function (value) {
      invertAxisLine = value || false;
      return xAxis;
    };
    xAxis.topMode = function () {
      mode = constants.AXIS.MODE.TOP;
      isTopAxis = mode === constants.AXIS.MODE.TOP;
      isBottomAxis = mode === constants.AXIS.MODE.BOTTOM;
      return xAxis;
    };
    xAxis.withTickValues = function (tickValues) {
      xAxisTickValues = tickValues;
      return xAxis;
    };
    return xAxis;
  };
  return Axis;
};
XAxis.$inject = ['d3Helper', 'ChartElementsConstants'];
module.exports = XAxis;